{
  "googleMaps": {
    "heading": "Are you on Google Maps ?",
    "linked": "Google Maps account linked",
    "placeholder": "Search your business name on Google Maps...",
    "providerId": "Account ID",
    "text": "Save time and import your data from Google Maps"
  },
  "heading": "Account"
}